import { get } from "lodash";

const styles = (theme) => ({
  root: {
    margin: "0 36px",
    backgroundColor: get(theme, 'color.uiBackground'),
    padding: "0 36px 100px 36px",
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  flexNonBetween: {
    display: "flex",
    alignItems: "center",
  },
  editIconButton: {
    fill: get(theme, 'color.primaryButtonBackground'),
    minWidth: 0,
    width: 35,
    height: 35,
    padding: 0,
    marginLeft: "1rem",
    marginTop: "1rem",
  },
  siteTitle: {
    wordWrap: 'break-word',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '50%',
  },
  siteTitleField: {
    '& .MuiFormControl-root': {
      width: '500px',
      marginTop: "2rem !important",
    },
  },
  siteTitleTextFieldClass: {
    '& div': {
      color: `${get(theme, 'color.bodyText')} !important`,
      fontSize: `${get(theme, 'fontSize.pageTitle')} !important`,
      fontWeight: 'bold',
    },
  },
  favIconContainer: {
    marginLeft: "3rem",
    marginTop: "2rem",
  },
  formTextFieldContainer: {
    width: "460px",
  },
  errorTextField: {
    marginTop: "35px !important",
  },
  formSelectLabel: {
    width: "201px !important",
    height: 20,
    '& label': {
      fontWeight: 400,
    },
  },
  selectField: {
    width: "455px !important",
  },
  formSelectField: {
    margin: "10px 0 !important",
  },
  selectFieldApiHubPrimary: {
    margin: "0 !important",
  },
  toolTipIcon: {
    marginTop: 15,
    marginLeft: 10,
    color: get(theme, 'color.primaryButtonBackground'),
  },
  displayToolTip: {
    color: get(theme, 'color.primaryButtonBackground'),
  },
  previewButton: {
    marginLeft: "2rem",
    marginTop: 10,
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  editButton: {
    marginTop: 10,
    marginLeft: "1rem",
    '& .MuiButton-root.Mui-disabled': {
      border: "none !important",
      backgroundColor: "none !important",
    },
    '& .MuiButton-text': {
      border: "none !important",
      backgroundColor: "none !important",
    },
  },
  editorContainer: {
    marginLeft: "2rem",
  },
  FormButtonGroupContainer: {
    width: 200,
    position: "relative",
  },
  buttonGroupToolTip: {
    position: "absolute",
    right: "1.8rem",
    top: "0",
    color: get(theme, 'color.primaryButtonBackground'),
  },
  errorMessage: {
    color: get(theme, 'color.error'),
  },
  uploadImageClass: {
    marginTop: "2rem",
  },
  cookieRoot: {
    borderRadius: 4,
    boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
    padding: 5,
    width: '80%',
  },
  rootTop: {
    top: 0,
  },
  rootBottom: {
    bottom: 0,
  },
  rootDark: {
    backgroundColor: get(theme, 'color.darkGreyBackground'),
    color: get(theme, 'color.white'),
    '& a': {
      color: `${get(theme, 'color.white')} !important`,
      textDecoration: 'underline !important',
    },
  },
  rootLight: {
    backgroundColor: get(theme, 'color.white'),
    color: get(theme, 'color.black'),
    '& a': {
      color: `${get(theme, 'color.link')} !important`,
      textDecoration: 'underline !important',
    },
  },
  editorContainerClass: {
    width: 800,
  },
});

export default styles;